import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import PdfInfoIcon from 'Views/Pages/Pdf/Components/PDFInfoIcon';
import { capitalize } from 'lodash';

const styles = StyleSheet.create({
	notice: {
		color: '#720017',
		display: 'flex',
		flexDirection: 'row',
		gap: 8,
	},
});

const PdfCourseSelectionNotice = () => {
	return (
		<View style={styles.notice} wrap={false}>
			<PdfInfoIcon />
			<Text style={{ fontWeight: 'bold' }}>{capitalize(window.lexicon.selectionNotice)}</Text>
			<Text>{capitalize(window.lexicon.selectionNotice)} does not meet requirements</Text>
		</View>
	);
};

export default PdfCourseSelectionNotice;
